export default __webpack_public_path__ + "static/media/21.aa6d8f4d.jpg";